import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const contantRoutes = [{
    path: '/',
    component: () => import('@/components/pc/pcPublic'),
    name: 'service',
    redirect: '/service',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    },
    children: [{
        path: '/service',
        component: () => import('@/components/pc/epubRead/epubRead'),
        name: 'service',
        meta: {
          title: '中国建筑工业出版社-资源阅读'
        },
      },     
      {
                path: '/books1',
                component: () => import('@/components/pc/gaoliang'),
                name: 'book',
                meta: {
                  title: '中国建筑工业出版社-资源阅读'
                },
              },
      {
        path: '/epubReadDemo',
        component: () => import('@/components/pc/epubRead/epubReadDemo'),
        name: 'epubReadDemo',
        meta: {
          title: '中国建筑工业出版社-资源阅读'
        },
      },
      {
        path: '/epubReadDemo2',
        component: () => import('@/components/pc/epubRead/epubReadDemo2'),
        name: 'epubReadDemo2',
        meta: {
          title: '中国建筑工业出版社-资源阅读'
        },
      },
      {
        path: '/epubReadDemo3',
        component: () => import('@/components/h5/mEpubRead/mKnowledge/com_mKnowledge'),
        name: 'epubReadDemo3',
        meta: {
          title: '中国建筑工业出版社-资源阅读'
        },
      },
      {
        path: '/prePicture',
        component: () => import('@/components/pc/epubRead/knowledge/prePicture'),
        name: 'prePicture',
        meta: {
          title: '中国建筑工业出版社-资源阅读'
        },
      },
      {
        path: '/readerPDF',
        component: () => import('@/components/pc/pdfRead/pdfRead'),
        name: 'readerPDF',
        meta: {
          title: '中国建筑工业出版社-资源阅读'
        }
      }
    ]
  },
  {
    path: '/read_al',
    component: () => import('@/components/h5/mEpubPublic'),
    name: 'mEpubRead',
    redirect: '/read_al',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    },
    children: [{
      path: '/read_al',
      component: () => import('@/components/h5/mEpubRead/mEpubRead'),
      name: 'mEpubRead',
      meta: {
        title: '中国建筑工业出版社-资源阅读'
      },
    }],
  }, {
    path: '/mCatalog',
    component: () => import('@/components/h5/mPictureView/mPictureView'),
    name: 'service',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  }, {
    path: '/read_cl',
    component: () => import('@/components/h5/mPlayer/index.vue'),
    name: 'read_cl',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  }, {
    path: '/mobiExamStart',
    component: () => import('@/components/h5/mPlayer/mPractice/mPractice'),
    name: 'mobiExamStart',
    meta: {
      title: '试卷'
    }
  }, {
    path: '/mobiExamContinue',
    component: () => import('@/components/h5/mPlayer/mPractice/mPractice'),
    name: 'mobiExamContinue',
    meta: {
      title: '试卷'
    }
  }, {
    path: '/mobiExercises',
    component: () => import('@/components/h5/mPlayer/mPractice/mPractice'),
    name: 'mobiExercises',
    meta: {
      title: '练习题'
    }
  }, {
    path: '/mReport',
    component: () => import('@/components/h5/mPlayer/mPractice/mReport'),
    name: 'mReport',
    meta: {
      title: '评分报告'
    }
  }, {
    path: '/mobiExamAnswer',
    component: () => import('@/components/h5/mPlayer/mPractice/mAnswer'),
    name: 'mobiExamAnswer',
    meta: {
      title: '查看答案'
    }
  }, {
    path: '/pcExercises',
    component: () => import('@/components/pc/player/practice/practice'),
    name: 'pcExercises',
    meta: {
      title: '练习题'
    }
  }, {
    path: '/pcExam',
    component: () => import('@/components/pc/player/exam/exam'),
    name: 'pcExam',
    meta: {
      title: '试卷'
    }
  }, {
    path: '/pcExamAnswer',
    component: () => import('@/components/pc/player/exam/exam'),
    name: 'pcExamAnswer',
    meta: {
      title: '试卷'
    }
  }, {
    path: '/pcCatalog',
    component: () => import('@/components/pc/pictureView/pictureView'),
    name: 'pictureView',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  {
    path: '/mreaderPDF',
    component: () => import('@/components/h5/mPdfRead/mreaderPDF'),
    name: 'readerPDF',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //下单
  {
    path: '/placeOrder',
    component: () => import('@/components/h5/pay/placeOrder'),
    name: 'placeOrder',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //收银台
  {
    path: '/cashier',
    component: () => import('@/components/h5/pay/cashier'),
    name: 'cashier',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //支付宝承载页
  {
    path: '/aliPay',
    component: () => import('@/components/h5/pay/aliPay'),
    name: 'aliPay',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //发票
  {
    path: '/invlist',
    component: () => import('@/components/h5/mobileInvoice/invoiceList'),
    name: 'invlist',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //发票
  {
    path: '/addInv',
    component: () => import('@/components/h5/mobileInvoice/addInvoice'),
    name: 'addInv',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //支付成功页
  {
    path: '/paySuccess',
    component: () => import('@/components/h5/pay/paySuccess'),
    name: 'paySuccess',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
  //知识体系-简介
  {
    path: '/knowledgeSystemsLis',
    component: () => import('@/components/h5/knowledgeSystems/knowledgeSystemsLis'),
    name: 'paySuccess',
    meta: {
      title: '中国建筑工业出版社-资源阅读'
    }
  },
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: contantRoutes
})

const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
Vue.directive('drag', {
    inserted: function (el) {
        (Array.from(el.querySelectorAll('*')).filter(v=>window.getComputedStyle(v)['cursor']=='move')).forEach((v)=>{
            v.onmousedown = function (e) { var x = e.pageX-el.offsetLeft, y = e.pageY-el.offsetTop;console.log('拖动',e)
            document.onmousemove = function (e) { el.style.left=e.pageX-x+'px'; el.style.top=e.pageY-y+'px'; }
            document.onmouseup   = function ()  { document.onmousemove = document.onmouseup = null; }};
        })
        // (Array.from(el.querySelectorAll('*')).find(v=>window.getComputedStyle(v)['cursor']=='move') || el).onmousedown = function (e) { var x = e.pageX-el.offsetLeft, y = e.pageY-el.offsetTop;console.log('拖动',e)
        // document.onmousemove = function (e) { el.style.left=e.pageX-x+'px'; el.style.top=e.pageY-y+'px'; }
        // document.onmouseup   = function ()  { document.onmousemove = document.onmouseup = null; }};
    },
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js